<template>
  <div class="home">
    <side-modal v-for="side in sides" :key="side.identidade"
      :tit="side.titulo"
      :subtit="side.subtitulo"
      :subtDetl="side.subtDetalhe"
      :larg="side.largura"
      :id="side.identidade"
      :abreMaisUm="side.abreProximo"
      :aberto="side.aberto"
      @fechou="fechaFromChild(side)"
      @abreFromChild="abreSide(sides[sides.indexOf(side) + 1])"
      @largura="minima" >
      <slot :name="side.identidade"></slot>
    </side-modal>
  </div>
</template>

<script>
import SideModal from './side-modal.vue'

export default {
  name: 'SideHome',

  props: {
    sides: {
      required: true,
      type: Array,
      default: [
        {
          titulo: 'Título',
          subtitulo: '',
          subtDetalhe: '',
          largura: 600,
          identidade: '',
          abreProximo: false,
          aberto: false
        }
      ]
    }
  },
  data () {
    return {
      largMinima: 0
    }
  },
  components: {
    'side-modal': SideModal
  },
  methods: {
    minima(larg) {
      this.larguraMinima = larg + 50
    },
    comparaSidesAbre (side) {
      let largMinima = side.largura
      let largAtual = 0

      this.sides.reverse ()
      this.sides.forEach (item => {
        largAtual = document.querySelector('#' + item.identidade).clientWidth
        if (item.aberto && largAtual <= largMinima) {
          largMinima += 50
          let prop = {id: item.identidade, larg: largMinima}
          this.$emit('mostraMais', prop)
        }
      })
      this.sides.reverse()
    },
    comparaSidesFecha (side) {
      let largAtual = 0
      let largResult = 0

      let abertos = this.sides.filter (item => item.aberto === true)
      abertos.reverse ()
      this.$emit('escondeMais', abertos[0])
      abertos.splice (0, 1)

      abertos.forEach (item => {
        largAtual = document.querySelector('#' + item.identidade).clientWidth

        if (item.largura !== largAtual && item.largura < largAtual) {
          this.largMinima > item.largura ? largResult = this.largMinima : largResult = item.largura
          let prop = {id: item.identidade, larg: largResult}
          this.$emit ('escondeMais', prop)
        } else {
          this.largMinima = item.largura + 50
        }
      })
    },
    abreSide (side) {
      const index = this.sides.indexOf (side)
      if ( index > 0 ) {
        this.comparaSidesAbre (side)
      }
      side.aberto = true
      this.$emit ('mostra', side.identidade)
    },
    fechaSide (side) {
      this.$emit ('esconde', side)
      this.fechaFromChild (side)
    },
    fechaFromChild (side) {
      side.aberto = false
      const index = this.sides.indexOf (side)
      if ( index > 0) {
        this.comparaSidesFecha (side)
      }
    }
  },
  created () {
    this.sides.forEach(side => {
      if (window.innerWidth < side.largura) side.largura = window.innerWidth
    })
    this.$parent.$on('abreModal', identidade => {
      const index = this.sides.findIndex(item => item.identidade === identidade)
      this.abreSide(this.sides[index])
      })
    this.$parent.$on('fechaModal', identidade => {
      const index = this.sides.findIndex(item => item.identidade === identidade)
      this.fechaSide(this.sides[index])
      })
  },
  mounted () {

  }
}
</script>



// WEBPACK FOOTER //
// index.vue?4c55c448